import clsx from "clsx";
import { useCallback, useRef, useState } from "react";

import type { VideoBlockType } from "@features/article-content/model";

import { Button } from "@shared/ui/button";
import { Icon } from "@shared/ui/icon";
import { Body } from "@shared/ui/typography";
import { Video } from "@shared/ui/video";

import s from "./video-block.module.scss";

export const VideoBlock = (props: VideoBlockType) => {
  const { video, author, authorUrl } = props;

  const $videoRef = useRef<HTMLVideoElement>(null);

  const [isPlay, setPlay] = useState(false);

  const togglePlayVideo = useCallback(() => {
    if ($videoRef.current) {
      if ($videoRef.current.paused) {
        $videoRef.current.muted = false;
        $videoRef.current.play();
        setPlay(true);
      } else {
        $videoRef.current.pause();
        setPlay(false);
      }
    }
  }, []);

  return (
    <div className={s.root}>
      <div className={s.videoWrapper} onClick={togglePlayVideo}>
        <Video ref={$videoRef} src={video?.url} muted className={s.video} />
        <div className={clsx(s.playButton, { [s.hideMobile]: isPlay })}>
          <Icon name={isPlay ? "pause" : "play"} />
        </div>
      </div>
      {author && (
        <Button className={s.author} href={authorUrl} target="_blank">
          <Icon size={16} name="arrow" className={s.arrowIcon} />
          <Body size="uppercase-small" weight="semiBold">
            {author}
          </Body>
        </Button>
      )}
    </div>
  );
};

VideoBlock.displayName = "VideoBlock";
